import { useContext } from "react";
import SelectedDataLakesContext from "data-lake/contexts/SelectedDataLakesContext";
const useSelectedDataLake = () => {
  const selectedDataLake = useContext(SelectedDataLakesContext);
  if (!selectedDataLake) {
    throw new Error("useSelectedDataLake hook needs to be used inside SelectedDataLakesContext.Provider");
  }
  return selectedDataLake;
};
export default useSelectedDataLake;
